__webpack_require__.p = "/aquisition-posting-details-contract-switching/referrals-hub/";